import Button from './Button';

export default Button;



// WEBPACK FOOTER //
// ./src/components/ui/Button/index.js